import React, { useEffect } from 'react';
import { Badge } from '@chakra-ui/react';
import { gql, useLazyQuery } from '@apollo/client';
const QUERY_COUNT = gql`
	query {
		getCountUnreadMissionRecord
	}
`;

function MissionRecordBadge() {
	const [loadCount, { data: countData }] = useLazyQuery(QUERY_COUNT);
	useEffect(() => {
		loadCount();
	}, []);
	return parseInt(countData?.getCountUnreadMissionRecord) > 0 ? (
		<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
			{parseInt(countData?.getCountUnreadMissionRecord)}
		</Badge>
	) : null;
}

export default MissionRecordBadge;
